import { getMarketCouponList } from './getMarketCouponList';
import { postRedeemAllMarketCoupon } from './postRedeemAllMarketCoupon';

export const marketCouponService = {
  get: getMarketCouponList,
  redeemAllCoupon: postRedeemAllMarketCoupon,
};
